module.exports = __webpack_public_path__ + "static/media/logo.a5f506f9.png";